import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Header } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import UiMeet3dEventType from "~/constants/UiMeet3d/UiMeet3dEventType";

const UiMeet3dEventTypeLabel = observer(({ type, t }) => {
  let label = null;

  // eslint-disable-next-line default-case
  switch (type) {
    case UiMeet3dEventType.FIRST_MOVE:
      label = t("clientPanelConstants:uiMeet3dEventTypeFirstMove");
      break;

    case UiMeet3dEventType.LEAD:
      label = t("clientPanelConstants:uiMeet3dEventTypeLead");
      break;

    case UiMeet3dEventType.MEETING_REQUEST:
      label = t("clientPanelConstants:uiMeet3dEventTypeMeetingRequest");
  }

  return (
    <Header as="p" color={type === UiMeet3dEventType.FIRST_MOVE ? "blue" : "green"}>
      {label}
    </Header>
  );
});

UiMeet3dEventTypeLabel.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.number.isRequired,
};

export default withTranslation()(UiMeet3dEventTypeLabel);
